module.exports = __webpack_public_path__ + "img/00-W.efa57e6f.svg";